import { render } from "./AuthOption.vue?vue&type=template&id=6bf5d0ae"
import script from "./AuthOption.vue?vue&type=script&lang=js"
export * from "./AuthOption.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__